import Vue from 'vue';
import Vuex from 'vuex';
import $ from 'jquery';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    hash: '',
    active: '',
    CartData: [],
    category: [],
    products: [],
    packages: [],
    packageCate: [],
    ship: [],
    productInfo: {
      type: '',
      data: [],
    },
    isLoading: false,
    expireProduct: [],
  },
  mutations: {
    setHash(state, payload) {
      state.hash = payload;
    },
    setActive(state, payload) {
      state.active = payload;
    },
    setProduct(state, payload) {
      state.category = payload.category;
      state.products = payload.item;
      state.packages = payload.package;
      state.packageCate = payload.packageCate;
    },
    // 加入購物車
    setAddCardData(state, payload) {
      const vm = this;
      vm.hasProduct = false;
      state.CartData.forEach((item, index) => {
        if (item.product_id === payload.product_id) {
          vm.hasProduct = true;
          state.CartData[index].count += parseInt(payload.count, 10);
          if (state.CartData[index].count <= 0) {
            state.CartData.splice(index, 1);
          }
          localStorage.setItem('cartdata', JSON.stringify(state.CartData));
        }
      });
      if (!vm.hasProduct) {
        state.CartData.push(payload);

        localStorage.setItem('cartdata', JSON.stringify(state.CartData));
      }
    },
    // 刪除購物車某項產品
    setLessCardData(state, payload) {
      state.CartData.forEach((item, index) => {
        if (item.product_id === payload.product_id) {
          if (state.CartData[index].count <= 1) {
            state.CartData.splice(index, 1);

            localStorage.setItem('cartdata', JSON.stringify(state.CartData));
          } else {
            state.CartData[index].count -= 1;

            localStorage.setItem('cartdata', JSON.stringify(state.CartData));
          }
        }
      });
    },
    // 加入所有運費方式
    setShipPrice(state, payload) {
      state.ship = payload;
    },
    // 將local資料放入購物車
    localStorageOverWrite(state, payload) {
      state.CartData = payload;
    },
    // 無法使用的商品
    setexpireProduct(state, payload) {
      state.expireProduct = payload;
    },
    setLoading(state, payload) {
      state.isLoading = payload;
    },
  },
  actions: {
    GET_ALL_PRODUCT({ commit }) {
      // const vm = this;
      commit('setLoading', true);
      $.ajax({
        url: `${process.env.VUE_APP_APIURL}front/page/new_index`,
        success(res) {
          console.log('home', res);
          const data = JSON.parse(res);
          // vm.category = data.category;
          // vm.products = data.item;
          // vm.packages = data.package;
          console.log(data);
          commit('setProduct', data);
          commit('setLoading', false);
        },
      });
    },
    ADD_TO_CART({ commit }, product) {
      commit('setAddCardData', product);
    },
    LESS_TO_CART({ commit }, productId) {
      commit('setLessCardData', productId);
    },
    GET_SHIP_PRICE({ commit }) {
      commit('setLoading', true);
      $.ajax({
        url: `${process.env.VUE_APP_APIURL}front/page/get_ship`,
        success(res) {
          const data = JSON.parse(res);
          console.log('所有運費', data);
          commit('setShipPrice', data);
          commit('setLoading', false);
        },
      });
    },
  },
  modules: {
  },
});
